/*
 * product-form-farbton.js: Ansicht und Vorwahl der eigenen Farbton-/Glanzgrad-Auswahl (statt MageWorx).
 * Plan: farbenloewe-kontext/reviews/2026-10-18-fl-picker-plan.md (Abschnitte 2 und 7). Server-HTML: snippets/product-info-farbton.liquid.
 *
 * Das Select <select name="properties[RAL Farbton]" required form="..."> und die Radios <input name="properties[Glanzgrad]"> sind der
 * EINZIGE Zustand. Dieses Skript baut daraus nur die bekannte Ansicht (Dropdown mit Farbfeldern, Glanzgrad-Knoepfe) und liest NIE in
 * die andere Richtung: die Anzeige wird aus dem Select gerendert. Damit gibt es ein Feld, einen Schreiber (schreibe) und eine
 * abgeleitete Anzeige. Der Wert ist immer der DEUTSCHE ("RAL 7016 Anthrazitgrau"), er steht nur in option/radio value, nie in
 * button.value (assets/fl-theme-i18n.js uebersetzt button.value).
 *
 * EINE Setzfunktion fuer alle Vorwahlen: window.flFarbton.setzen({ farbton, glanz }, quelle), lesen() liefert den Stand.
 * Rang der Quellen, hoch gewinnt: kunde (4) > url (3: ?ral=, ?xl8rd--color=) > set (2: Set-Auswahl, Zustand der Nachbarseite) > besuch (1).
 * Eine niedrigere Quelle ueberschreibt nie eine hoehere; nach einer Kundenwahl setzt nichts mehr (Vorfall 18.09.2026: eine Vorwahl
 * ueberschrieb die Kundenwahl). Ein vom Browser wiederhergestellter Wert (Zurueck-Taste, Neuladen) gilt als Kundenwahl.
 * Gesetzt wird ueber die NUMMER des Tons ("RAL 5001"), nie ueber Teilstrings oder den uebersetzten Text.
 *
 * Die Vorwahl laeuft erst bei Aktivierung der Seite (document.prerendering): Die Set-Auswahl laesst Nachbarseiten vorab rendern, und eine
 * vorab gerenderte Seite haette sonst einen Stand von VOR dem Klick gesetzt.
 *
 * Shopify liefert Theme-Assets minifiziert aus (Kommentare fallen weg). Der "schon geladen"-Marker steht deshalb in Code (window.flFarbton).
 */
(function () {
  'use strict'

  if (window.flFarbton) return

  var RANG = { besuch: 1, set: 2, url: 3, kunde: 4 }
  var KEY_BESUCH = 'fl_ral_herkunft'

  var wurzel = null
  var auswahl = null
  var radios = []
  var boxFarbton = null
  var boxGlanz = null
  var knopf = null
  var anzeige = null
  var liste = null
  var herkunft = { farbton: 0, glanz: 0 }
  var wartend = []
  var ungueltigLaeuft = false
  var protokoll = { stand: 'gestartet' }

  // ---- Hilfen ---------------------------------------------------------------
  function rangVon (quelle) { return RANG[quelle] || RANG.set }   // eine unbekannte Quelle zaehlt nie als Kunde

  function nummerAus (text) {
    var t = String(text == null ? '' : text)
    var m = t.match(/RAL\s*(\d{4})/i) || t.match(/^\s*(\d{4})\s*$/)
    return m ? m[1] : null
  }

  function dekodiert (roh) {
    var t = String(roh == null ? '' : roh)
    for (var i = 0; i < 2 && t.indexOf('%') >= 0; i++) {
      try { t = decodeURIComponent(t) } catch (e) { break }
    }
    return t
  }

  function optionFuer (wert) {
    var w = String(wert == null ? '' : wert).trim()
    if (!auswahl || !w) return null
    var nr = nummerAus(w)
    var i
    if (nr) {
      // Mit Nummer zaehlt NUR die Nummer: "RAL 5010 irgendein Name" trifft Enzianblau, ein Ton ohne Option trifft nichts.
      for (i = 1; i < auswahl.options.length; i++) if (auswahl.options[i].getAttribute('data-ral') === nr) return auswahl.options[i]
      return null
    }
    var klein = w.toLowerCase()
    for (i = 1; i < auswahl.options.length; i++) if (auswahl.options[i].value.toLowerCase() === klein) return auswahl.options[i]
    for (i = 1; i < auswahl.options.length; i++) if ((auswahl.options[i].textContent || '').trim().toLowerCase() === klein) return auswahl.options[i]
    return null
  }

  function radioFuer (wert) {
    var klein = String(wert == null ? '' : wert).trim().toLowerCase()
    if (!klein) return null
    var i
    for (i = 0; i < radios.length; i++) if (radios[i].value.toLowerCase() === klein) return radios[i]
    for (i = 0; i < radios.length; i++) {
      var s = radios[i].parentNode && radios[i].parentNode.querySelector('span')
      if (s && (s.textContent || '').trim().toLowerCase() === klein) return radios[i]
    }
    return null
  }

  function gewaehlterRadio () {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i]
    return null
  }

  function melden (feld, wert, quelle) {
    try {
      wurzel.dispatchEvent(new CustomEvent('fl-farbton:change', { bubbles: true, detail: { feld: feld, wert: wert, quelle: quelle } }))
    } catch (e) { /* alte Browser: die Anzeige stimmt trotzdem */ }
  }

  // ---- Die einzige Schreibstelle -----------------------------------------------
  // Rueckgabe: 'gesetzt', 'gleich', 'abgelehnt' (hoeherer Rang steht schon), 'nicht-gefunden'.
  function schreibe (feld, roh, rang) {
    if (rang < herkunft[feld]) return 'abgelehnt'
    var ziel = feld === 'farbton' ? optionFuer(roh) : radioFuer(roh)
    if (!ziel) return 'nicht-gefunden'
    var gleich
    if (feld === 'farbton') {
      gleich = auswahl.value === ziel.value
      auswahl.value = ziel.value
    } else {
      gleich = ziel.checked
      ziel.checked = true
    }
    herkunft[feld] = rang
    rendern()
    if (!gleich) melden(feld, feld === 'farbton' ? auswahl.value : ziel.value, rang)
    return gleich ? 'gleich' : 'gesetzt'
  }

  function setzen (werte, quelle) {
    if (!wurzel) return { fehler: 'kein-picker' }
    if (document.prerendering) { wartend.push([werte, quelle]); return { stand: 'wartet-auf-aktivierung' } }
    var rang = rangVon(quelle)
    var res = {}
    werte = werte || {}
    if (auswahl && werte.farbton != null && werte.farbton !== '') res.farbton = schreibe('farbton', werte.farbton, rang)
    if (radios.length && werte.glanz != null && werte.glanz !== '') res.glanz = schreibe('glanz', werte.glanz, rang)
    return res
  }

  function lesen () {
    var r = gewaehlterRadio()
    return { farbton: auswahl ? auswahl.value : '', glanz: r ? r.value : '', herkunft: { farbton: herkunft.farbton, glanz: herkunft.glanz } }
  }

  // ---- Ansicht: immer aus dem Select/den Radios gerendert, nie umgekehrt ---------
  function rendern () {
    var i
    if (auswahl && anzeige) {
      var o = auswahl.selectedIndex >= 0 ? auswahl.options[auswahl.selectedIndex] : null
      var text = (auswahl.value && o) ? o.textContent : (auswahl.options[0] ? auswahl.options[0].textContent : '')
      if (anzeige.textContent !== text) anzeige.textContent = text
      var gefunden = false
      var knoepfe = liste ? liste.querySelectorAll('button.color-option') : []
      for (i = 0; i < knoepfe.length; i++) {
        var ist = !gefunden && !!auswahl.value && knoepfe[i].getAttribute('data-value') === auswahl.value
        if (ist) gefunden = true
        knoepfe[i].classList.toggle('active', ist)
        knoepfe[i].setAttribute('aria-selected', ist ? 'true' : 'false')
      }
      if (auswahl.value && boxFarbton) {
        boxFarbton.classList.remove('show_error')
        var h = boxFarbton.querySelector('[data-fl-farbton-hinweis]')
        if (h) h.parentNode.removeChild(h)
      }
    }
    var gew = gewaehlterRadio()
    for (i = 0; i < radios.length; i++) {
      var label = radios[i].parentNode
      if (label && label.classList) label.classList.toggle('active', radios[i].checked)
    }
    if (gew && boxGlanz) boxGlanz.classList.remove('show_error')
  }

  function oeffnen () {
    if (!boxFarbton || !knopf) return
    boxFarbton.classList.add('show')
    knopf.setAttribute('aria-expanded', 'true')
  }

  function schliessen () {
    if (!boxFarbton || !knopf) return
    boxFarbton.classList.remove('show')
    knopf.setAttribute('aria-expanded', 'false')
  }

  function bauen () {
    knopf = document.createElement('button')
    knopf.type = 'button'
    knopf.className = 'property-colortype_dropdown'
    knopf.setAttribute('aria-haspopup', 'listbox')
    knopf.setAttribute('aria-expanded', 'false')
    anzeige = document.createElement('div')
    anzeige.className = 'property-colortype_dropdownSelected'
    var pfeil = document.createElement('div')
    pfeil.className = 'dropdown_arrow'
    pfeil.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none" aria-hidden="true"><path d="M7.71835 2.96969L4.4986 6.18944L1.27885 2.96969C1.13739 2.83307 0.947943 2.75747 0.751296 2.75918C0.554648 2.76089 0.366539 2.83977 0.227482 2.97882C0.0884264 3.11788 0.00954967 3.30599 0.00784085 3.50264C0.00613204 3.69929 0.0817278 3.88874 0.218346 4.03019L3.96835 7.78019C4.10899 7.92079 4.29972 7.99978 4.4986 7.99978C4.69747 7.99978 4.8882 7.92079 5.02885 7.78019L8.77885 4.03019C8.85048 3.961 8.90762 3.87825 8.94692 3.78674C8.98623 3.69524 9.00692 3.59682 9.00778 3.49724C9.00865 3.39766 8.98967 3.2989 8.95196 3.20672C8.91425 3.11455 8.85856 3.03081 8.78814 2.96039C8.71772 2.88997 8.63398 2.83428 8.54181 2.79657C8.44964 2.75886 8.35088 2.73989 8.2513 2.74075C8.15171 2.74162 8.0533 2.76231 7.96179 2.80161C7.87029 2.84092 7.78753 2.89806 7.71835 2.96969Z" fill="black"/></svg>'
    knopf.appendChild(anzeige)
    knopf.appendChild(pfeil)

    liste = document.createElement('div')
    liste.className = 'property_dropdownOptions'
    liste.setAttribute('role', 'listbox')
    for (var i = 1; i < auswahl.options.length; i++) {
      var o = auswahl.options[i]
      var b = document.createElement('button')
      b.type = 'button'
      b.className = 'color-option'
      b.setAttribute('role', 'option')
      b.setAttribute('aria-selected', 'false')
      b.setAttribute('data-value', o.value)
      var feld = document.createElement('span')
      feld.className = 'color-option__feld'
      feld.setAttribute('aria-hidden', 'true')
      var hex = o.getAttribute('data-hex')
      if (hex) feld.style.background = '#' + hex
      else feld.className += ' color-option__feld--farblos'
      b.appendChild(feld)
      b.appendChild(document.createTextNode(o.textContent))
      liste.appendChild(b)
    }
    auswahl.insertAdjacentElement('afterend', knopf)
    knopf.insertAdjacentElement('afterend', liste)

    knopf.addEventListener('click', function (e) {
      e.stopPropagation()
      if (boxFarbton.classList.contains('show')) schliessen(); else oeffnen()
    })
    liste.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button.color-option') : null
      if (!b) return
      // Nur ein echter Klick des Kunden zaehlt als Kundenwahl; ein Skript, das .click() ruft, ist eine Vorwahl.
      schreibe('farbton', b.getAttribute('data-value'), e.isTrusted ? RANG.kunde : RANG.set)
      schliessen()
    })
    document.addEventListener('click', function (e) {
      if (boxFarbton.classList.contains('show') && !boxFarbton.contains(e.target)) schliessen()
    })
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && boxFarbton.classList.contains('show')) { schliessen(); knopf.focus() }
    })

    wurzel.classList.add('fl-farbton--bereit')
    auswahl.setAttribute('tabindex', '-1')
    auswahl.setAttribute('aria-hidden', 'true')
  }

  // ---- Pflicht: der Browser sperrt, wir zeigen die Meldung im Block ---------------
  function ungueltig (e) {
    e.preventDefault()   // die Browserblase unterdruecken, die Meldung steht im Block
    var box = e.target.closest ? e.target.closest('.product-property_container') : null
    if (!box) return
    box.classList.add('show_error')
    if (ungueltigLaeuft) return
    ungueltigLaeuft = true
    window.setTimeout(function () { ungueltigLaeuft = false }, 0)
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch (x) { box.scrollIntoView() }
    if (box === boxFarbton && knopf) {
      oeffnen()
      try { knopf.focus({ preventScroll: true }) } catch (x2) { /* ohne Fokus-Optionen */ }
    } else {
      var r = box.querySelector('input')
      if (r) { try { r.focus({ preventScroll: true }) } catch (x3) { /* ohne Fokus-Optionen */ } }
    }
  }

  // Ein vom Browser wiederhergestellter Wert (Zurueck-Taste, Neuladen) gilt als Kundenwahl.
  function adoptieren () {
    if (auswahl && auswahl.value && herkunft.farbton === 0) herkunft.farbton = RANG.kunde
    if (gewaehlterRadio() && herkunft.glanz === 0) herkunft.glanz = RANG.kunde
  }

  // ---- Vorwahl --------------------------------------------------------------------
  function merken (ton) {
    try { window.sessionStorage.setItem(KEY_BESUCH, 'farbton:' + ton) } catch (e) { /* privater Modus: die Messung entfaellt, die Vorwahl nicht */ }
  }

  function besuchTon () {
    try {
      var m = String(window.sessionStorage.getItem(KEY_BESUCH) || '').match(/^farbton:(\d{4})$/)
      return m ? m[1] : null
    } catch (e) { return null }
  }

  function hinweisZeigen (ton) {
    if (!boxFarbton || boxFarbton.querySelector('[data-fl-farbton-hinweis]')) return
    var vorlage = wurzel.getAttribute('data-fl-hinweis')
    if (!vorlage) return
    var p = document.createElement('p')
    p.className = 'fl-farbton__hinweis'
    p.setAttribute('data-fl-farbton-hinweis', '1')
    p.setAttribute('role', 'status')
    p.textContent = vorlage.replace('####', ton)
    boxFarbton.appendChild(p)
  }

  function ausDerAdresse (ton, quelle) {
    if (!auswahl) return 'keine-auswahl'
    var opt = optionFuer('RAL ' + ton)
    if (!opt) {
      if (herkunft.farbton < RANG.kunde) hinweisZeigen(ton)
      return 'ton-nicht-lieferbar'
    }
    return schreibe('farbton', opt.value, rangVon(quelle))
  }

  function vorwahlen () {
    var q = new URLSearchParams(window.location.search)
    var erg = []
    // 1. Wunsch der Set-Auswahl, falls sie ihn ablegte, bevor die Schnittstelle da war
    var ab = wurzel.getAttribute('data-fl-set')
    if (ab) {
      wurzel.removeAttribute('data-fl-set')
      try { setzen(JSON.parse(ab), 'set'); erg.push('set') } catch (e) { protokoll.setFehler = String(e && e.message) }
    }
    // 2. ?ral=5010, ?ral=RAL5010, ?ral=RAL 5010: genau 4 Ziffern. Vorhanden, aber unbrauchbar: nichts setzen, nicht raten.
    var roh = q.get('ral')
    if (roh != null) {
      var z = String(roh).replace(/[^0-9]/g, '')
      if (/^\d{4}$/.test(z)) {
        merken(z)
        erg.push('ral:' + ausDerAdresse(z, 'url'))
        protokoll.ton = z
      } else {
        erg.push('ral:unbrauchbar')
      }
    } else {
      // 3. Link aus einer Sammlungsseite: ?xl8rd--color=RAL%209003%20Signalwei%C3%9F; die Nummer zaehlt, nicht der Text.
      var xl = q.get('xl8rd--color')
      if (xl != null) {
        var n = nummerAus(dekodiert(xl))
        if (n) { erg.push('xl8rd:' + ausDerAdresse(n, 'url')); protokoll.ton = n } else erg.push('xl8rd:ohne-nummer')
      }
      // 4. Besuchsgedaechtnis: nur wenn dieser Besuch ueber eine Farbtonseite kam (die Kacheln der Set-Auswahl navigieren ohne ?ral=).
      var b = besuchTon()
      if (b) { erg.push('besuch:' + ausDerAdresse(b, 'besuch')); protokoll.quelle = 'besuch' }
    }
    protokoll.vorwahl = erg.join(',')
  }

  function aktiviert (f) {
    if (document.prerendering) document.addEventListener('prerenderingchange', f, { once: true })
    else f()
  }

  // ---- Start ----------------------------------------------------------------------
  window.flFarbton = { aktiv: true, setzen: setzen, lesen: lesen, protokoll: protokoll }

  function start () {
    wurzel = document.querySelector('[data-fl-farbton]')
    if (!wurzel) { protokoll.stand = 'kein-picker'; return }
    auswahl = wurzel.querySelector('select.fl-farbton__select')
    radios = [].slice.call(wurzel.querySelectorAll('input.fl-farbton__radio'))
    boxFarbton = wurzel.querySelector('[data-fl-farbton-box="ral"]')
    boxGlanz = wurzel.querySelector('[data-fl-farbton-box="glanz"]')

    if (auswahl) {
      bauen()
      auswahl.addEventListener('change', function (e) {
        if (e.isTrusted) { herkunft.farbton = RANG.kunde; melden('farbton', auswahl.value, RANG.kunde) }
        rendern()
      })
      auswahl.addEventListener('invalid', ungueltig)
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function (e) {
        if (e.isTrusted) { herkunft.glanz = RANG.kunde; melden('glanz', r.value, RANG.kunde) }
        rendern()
      })
      r.addEventListener('invalid', ungueltig)
    })

    adoptieren()
    rendern()
    window.addEventListener('pageshow', function () { adoptieren(); rendern() })
    window.addEventListener('load', function () { adoptieren(); rendern() })

    aktiviert(function () {
      adoptieren()
      var w = wartend
      wartend = []
      for (var i = 0; i < w.length; i++) setzen(w[i][0], w[i][1])
      vorwahlen()
      protokoll.stand = 'bereit'
    })
  }

  start()
})()
